import {Component, OnInit} from '@angular/core';
import {PageDTO} from '../../../../common/dtos/PageDTO';
import {CollegeInfoService} from '../../services/college-info.service';
import {DictionaryService} from '../../../shared/services/dictionary.service';
import {Utils} from '../../../../common/services/Utils';
import {MatDialog} from '@angular/material';
import {CommonService} from '../../../shared/services/common.service';
import {GraduateRegisterService} from '../../../shared/services/graduate-register.service';
import {Language} from '../../../../common/models/language';
import {RegisterGraduateActionDialogComponent} from '../register/register-graduate-action-dialog/register-graduate-action-dialog.component';
import {LangChange} from '../../../../lang-change';
import {Page} from '../../../moderator/components/add-edit-page/model/page';
import {EnrollApplicationService} from '../../services/enroll-application.service';

@Component({
  selector: 'app-enroll-exam-results',
  templateUrl: './enroll-exam-results.component.html',
  styleUrls: ['./enroll-exam-results.component.scss']
})
export class EnrollExamResultsComponent extends LangChange implements OnInit {
  page = new PageDTO();
  collegeList = [];
  enterExamTypeList = [];
  enrollList = [];
  centerProfessionList: any[];
  logoMiniPath = `assets/images/logos/${window.location.hostname}/pem_logo_footer.png`;
  constructor(private _universityInfoService: CollegeInfoService,
              private _dictionaryService: DictionaryService,
              private _utils: Utils,
              private _dialog: MatDialog,
              private _commonService: CommonService,
              private _enrollService: EnrollApplicationService) {
    super(_utils._translateService);
    this.page.size = 20;
    this.page.filter = {
      search: null,
      collegeId: null,
      enterExamTypeId: null,
      professionId: null
    };
  }

  ngOnInit() {
    this._universityInfoService.getNotCivilCollegeList().subscribe(list => {
      this.collegeList = this._utils.translateListWithSort(list, 'name');
    });

    this._dictionaryService.getAllCenterProfessionList().subscribe(list => {
      this.centerProfessionList = this.translateProfessionList(list);
    });

    this.enterExamTypeList.push({id: 0, name: this._utils._translateService.instant('All')});
    // this.enterExamTypeList.push({id: 1, name: this._utils._translateService.instant('enroll_cabinet_page.edu_info_tab.type_of_admission.ent')});
    this.enterExamTypeList.push({id: 3, name: this._utils._translateService.instant('enroll_cabinet_page.edu_info_tab.type_of_admission.exam')});
    this.enterExamTypeList.push({id: 2, name: this._utils._translateService.instant('enroll_cabinet_page.edu_info_tab.type_of_admission.interview')});

    this.reloadList();
  }

  translateProfessionList(list) {
    if (list && list.length) {
      for (let i = 0; i < list.length; i++) {
        list[i].fullName = list[i].code + ' ' + this._utils.getMultiValue(list[i], 'name');
      }
      return list.sort((a, b) => a.fullName.localeCompare(b.fullName));
    }
  }

  clearAllParams() {
    this.page.filter = {
      search: null,
      collegeId: null,
      admissionTypeId: null,
      professionId: null
    };
    this.enrollList = [];
  }

  onLangChange(language): void {
    this.collegeList = this._utils.translateListWithSort(this.collegeList, 'name');
    this.centerProfessionList = this.translateProfessionList(this.centerProfessionList);
    // this.citizenshipList = this._utils.translateListWithSort(this.citizenshipList, 'name');

  }

  reloadList(resetPage?) {
    if (resetPage) {
      this.page.pageNumber = 0;
    }

    this._enrollService.getEnrollsExamResultList(this.page).subscribe(resp => {
      this.page.totalElements = resp.totalElements;
      this.enrollList = resp.dtoList;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/enroll-exam-results/enroll-exam-results.component.ts